import React from 'react'
import { safeLazy } from '../utils/SafeLazy/SafeLazy'
import ChunkLoader from '../components/ChunkLoader/ChunkLoader'

export const CREATE_CAMPAIGN_PATH = '/create-campaign'

const ImportPage = safeLazy(() => import('../pages/Import/ImportPage'))

export const IMPORT_ROUTES = [
	{
		path: CREATE_CAMPAIGN_PATH,
		element: (
			<ChunkLoader>
				<ImportPage />
			</ChunkLoader>
		),
	},
]
